import { useApp } from '../../context/AppContext';
import './Footer.css';

const Footer = () => {
  const { setCurrentView } = useApp();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section footer-brand-section">
          <p className="footer-brand">GoSplitPDF</p>
          <p className="footer-tagline">Free Online PDF Tools</p>
          <p className="footer-privacy-badge">
            <span className="privacy-icon">🔒</span>
            Secure & Private
          </p>
        </div>

        {/* Tools Section */}
        <div className="footer-section footer-links-section">
          <h4 className="footer-heading">Tools</h4>
          <nav className="footer-nav">
            <button onClick={() => setCurrentView('merge')}>Merge PDF</button>
            <button onClick={() => setCurrentView('split')}>Split PDF</button>
            <button onClick={() => setCurrentView('convert')}>Convert to PDF</button>
            <button onClick={() => setCurrentView('sign')}>Sign PDF</button>
          </nav>
        </div>

        {/* Support Section */}
        <div className="footer-section footer-links-section">
          <h4 className="footer-heading">Support</h4>
          <nav className="footer-nav">
            <button onClick={() => setCurrentView('faq')}>FAQ</button>
            <button onClick={() => setCurrentView('contact')}>Contact Us</button>
          </nav>
        </div>

        {/* Legal Section */}
        <div className="footer-section footer-links-section">
          <h4 className="footer-heading">Legal</h4>
          <nav className="footer-nav">
            <button onClick={() => setCurrentView('privacy')}>Privacy Policy</button>
            <button onClick={() => setCurrentView('terms')}>Terms of Service</button>
          </nav>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          © {currentYear} GoSplitPDF. All rights reserved.
        </p>
        <p className="footer-domain">
          <a href="https://gosplitpdf.com" target="_blank" rel="noopener noreferrer">
            gosplitpdf.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
